import React, { Fragment, useState, useEffect } from 'react';
import Formulario from './components/Formulario';
import Song from './components/Song';
import Info from './components/Info';

import axios from 'axios';


function App() {

  // definir el state
  const [searchSong, saveSearchSong] = useState({});
  const [lyric, saveLyric] = useState('');
  const [info, saveInfo] = useState({});

  useEffect(() => {
    if (Object.keys(searchSong).length === 0) return;

    const consultSongApi = async () => {

      const { artist, song } = searchSong;
      const url = `https://api.lyrics.ovh/v1/${artist}/${song}`;
      const url2 = `https://www.theaudiodb.com/api/v1/json/1/search.php?s=${artist}`;

      const [lyric, informacion] = await Promise.all([
        axios.get(url),
        axios.get(url2)
      ]);

      saveLyric(lyric.data.lyrics);
      saveInfo(informacion.data.artists[0]);

      saveSearchSong({});
    }
    consultSongApi();
  }, [searchSong, info]);

  return (
    <Fragment>
      <Formulario
        saveSearchSong={saveSearchSong}
      />

      <div className="container mt-5">
        <div className="row">
          <div className="col-md-6">
            <Info 
              info={info}
            />
          </div>
          <div className="col-md-6">
            <Song 
              lyric={lyric}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
}


export default App;



// WEBPACK FOOTER //
// ./src/App.js